import Vue from "vue";
import VueRouter from "vue-router";
import i18n from "@/libs/i18n";
import { $themeConfig } from "@themeConfig";

// Routes
import { canNavigate } from "@/libs/acl/routeProtection";
import {
  isUserLoggedIn,
  getUserData,
  getHomeRouteForLoggedInUser,
} from '@/auth/utils'
import errors from './routes/errors'
import auth from './routes/auth'
import register from './routes/register'
import invitation from './routes/invitation'
import forgotPassword from './routes/forgotPassword'
import profile from './routes/profile'
import chat from './routes/chat'
import chatAssignment from './routes/chatAssignment'
import chatPage from './routes/chatPage'
import chatSettings from './routes/chatSettings'
import conversationOverview from './routes/conversationOverview'
import customerSatification from './routes/customerSatification'
import teamPerformance from './routes/teamPerformance'
import general from './routes/general'
import chatWidget from './routes/chatWidget'
import integration from './routes/integration'
import businessInformation from './routes/businessInformation'
import operator from './routes/operator'
import role from './routes/role'
import ticket from './routes/ticket'
import quickMessage from './routes/quickMessage'
import bot from './routes/bot'
import call from './routes/call'
import callCenter from './routes/callCenter'
import callCenterOverview from './routes/callCenterOverview'
import callSatisfaction from './routes/callSatisfaction'
import chatPartner from './routes/chatPartner'
import voiceAlertSettings from './routes/voiceAlertSettings'
import department from './routes/department'
import holiday from './routes/holiday'
import question from './routes/question'
import serviceSystem from './routes/serviceSystem'
import employeePerformanceOverview from './routes/employeePerformanceOverview'
import service from './routes/service'
import serviceSystemSetting from './routes/serviceSystemSetting'
import project from './routes/project'
import workingSchedule from './routes/workingSchedule'
import serviceOverview from "./routes/serviceOverview";
import whitelistIP from './routes/whitelistIP'

Vue.use(VueRouter)

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  scrollBehavior() {
    return { x: 0, y: 0 }
  },
  routes: [
    {
      path: '/',
      name: 'dashboard',
      component: () => import('@/views/Home.vue'),
      meta: {
        pageTitle: 'breadcrumb.dashboard',
        resource: 'dashboard',
        breadcrumb: [
          {
            text: 'breadcrumb.dashboard',
            active: true,
          },
        ],
      },
    },
    ...voiceAlertSettings,
    ...chatPartner,
    ...call,
    ...callCenterOverview,
    ...callCenter,
    ...bot,
    ...ticket,
    ...errors,
    ...auth,
    ...register,
    ...invitation,
    ...forgotPassword,
    ...profile,
    ...chat,
    ...chatAssignment,
    ...chatPage,
    ...chatSettings,
    ...conversationOverview,
    ...customerSatification,
    ...teamPerformance,
    ...chatWidget,
    ...integration,
    ...businessInformation,
    ...quickMessage,
    ...operator,
    ...role,
    ...general,
    ...callSatisfaction,
    ...department,
    ...holiday,
    ...question,
    ...serviceSystem,
    ...employeePerformanceOverview,
    ...service,
    ...serviceSystemSetting,
    ...project,
    ...workingSchedule,
    ...serviceOverview,
    ...whitelistIP,
    {
      path: '*',
      redirect: 'error-404',
    },
  ],
})

// Method using PUSH
const RouterPush = VueRouter.prototype.push;
VueRouter.prototype.push = function push(to) {
  return RouterPush.call(this, to).catch((err) => err);
};

// Method using Replace
const RouterReplace = VueRouter.prototype.replace;
VueRouter.prototype.replace = function replace(to) {
  return RouterReplace.call(this, to).catch((err) => err);
};

router.beforeEach((to, _, next) => {
  Vue.nextTick(() => {
    const { appName } = $themeConfig.app;
    document.title = `${to.meta.title ? i18n.tc(to.meta.title) : i18n.tc(to.meta.pageTitle)
      } | ${appName}`;
  });

  const isLoggedIn = isUserLoggedIn();
  if (!canNavigate(to)) {
    // Redirect to login if not logged in
    if (!isLoggedIn) {
      return next({
        name: "login",
        query: {
          redirect: to.fullPath,
        },
      });
    }

    // If logged in => not authorized
    return next({ name: "not-authorized" });
  }

  // Redirect if logged in
  if (to.meta.redirectIfLoggedIn && isLoggedIn) {
    const userData = getUserData();
    next(
      getHomeRouteForLoggedInUser(
        userData ? "admin" : null,
        null,
        userData.ability,
      ),
    );
  }

  return next()
})

export default router
